import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VSkeletonLoader,{staticClass:"skeleton-loader",class:_setup.skeletonClasses,style:({ maxWidth: _vm.maxWidth, height: _vm.height }),attrs:{"type":"image"}})
}
var staticRenderFns = []

export { render, staticRenderFns }